__turbopack_context__.v({
  "className": "caveat_229a0440-module__LGVYkW__className",
});
